import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { animationTransition } from '@shared/utils/animationTransition';

export const HeaderLinksContainer = styled(Flex)``;
const headerLinksContainerStyles = (isActive: boolean): StyleSystemProps => ({
  color: isActive ? 'purple7' : 'mono14',
  alignItems: 'center',
  fontWeight: 'medium',
  paddingX: 4,
  paddingY: pxToRem(14),
  whiteSpace: 'nowrap',
  transition: animationTransition('color'),
  cursor: 'pointer',
  fontFamily: 'Inter UI',
  fontSize: pxToRem(16),
  lineHeight: pxToRem(22),
  letterSpacing: '0.005em',
});

export const styles = {
  headerLinksContainer: headerLinksContainerStyles,
};
